/**
 * CaixaLocalRepository
 *
 * Abstrai o acesso à tabela `caixa_local` via Electron IPC.
 * Reflete a tabela `caixa` do backend e é sincronizado depois
 * via endpoint POST /api/offline/caixa/sincronizar.
 */
import { getElectronAPI } from "@/plugins/desktop";

/**
 * Tipos de movimento conforme tabela `caixa` do back_nuts.
 * Mantidos em sincronia com a constante CAIXA_TIPO no Electron.
 */
export const CAIXA_TIPO = {
  ABERTURA:   1,
  VENDA:      2,
  SANGRIA:    3,
  SUPRIMENTO: 4,
  FECHAMENTO: 5,
};

const CaixaLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async buscarCaixaAberto() {
    return this._api().caixa.buscarAberto();
  },

  async criarAberturaCaixa(payload) {
    return this._api().caixa.criarAbertura(payload);
  },

  async registrarMovimentoVenda(payload) {
    return this._api().caixa.registrarVenda(payload);
  },

  async registrarSangria(payload) {
    return this._api().caixa.registrarSangria(payload);
  },

  async registrarEstornoPreVenda(uuid_venda_terminal) {
    return this._api().caixa.registrarEstornoPreVenda(uuid_venda_terminal);
  },

  async registrarSuprimento(payload) {
    return this._api().caixa.registrarSuprimento(payload);
  },

  async registrarFechamento(payload) {
    return this._api().caixa.registrarFechamento(payload);
  },

  async buscarMovimentosPorUuidCaixa(uuid_caixa) {
    return this._api().caixa.buscarMovimentos(uuid_caixa);
  },

  async buscarUltimoCaixa() {
    return this._api().caixa.buscarUltimoCaixa();
  },

  async buscarPendentesSync(opcoes) {
    return this._api().caixa.buscarPendentesSync(opcoes);
  },

  async marcarSincronizado(uuid, retorno) {
    return this._api().caixa.marcarSincronizado(uuid, retorno);
  },

  async marcarErroSync(uuid, erro) {
    return this._api().caixa.marcarErroSync(uuid, erro);
  },

  async marcarErroSyncCaixa(uuid_caixa, erro) {
    return this._api().caixa.marcarErroSyncCaixa(uuid_caixa, erro);
  },

  async atualizarCaixaSync(uuid_caixa, retorno) {
    return this._api().caixa.atualizarCaixaSync(uuid_caixa, retorno);
  },

  async buscarPorUuid(uuid) {
    return this._api().caixa.buscarPorUuid(uuid);
  },

  async salvarComprovante(uuid, html) {
    return this._api().caixa.salvarComprovante(uuid, html);
  },

  async marcarComprovanteImpresso(uuid) {
    return this._api().caixa.marcarComprovanteImpresso(uuid);
  },

  async incrementarReimpressao(uuid) {
    return this._api().caixa.incrementarReimpressao(uuid);
  },
};

export default CaixaLocalRepository;
